import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { AuthProvider, useAuth } from "./auth";
import { Claim } from "./pages/Claim";
import { ComingSoon } from "./pages/ComingSoon";
import { DeviceSettings } from "./pages/DeviceSettings";
import { Devices } from "./pages/Devices";
import { Diary } from "./pages/Diary";
import { IncidentView } from "./pages/IncidentView";
import { AppHeader } from "./components/AppHeader";
import { Login, SetNewPassword } from "./pages/Login";

import "./theme.css";

/** Everything is behind sign-in. The gate sits above the routes, so the URL
 *  survives signing in — a QR-code claim link still claims afterwards. */
function Gate() {
  const { session, loading, recovering, recoveryDone, signOut } = useAuth();

  if (loading) return <div className="centre"><div className="spinner" /></div>;
  if (!session) return <Login />;
  // Arrived from a password-reset email: choose the new password first.
  if (recovering) return <SetNewPassword onDone={recoveryDone} />;

  return (
    <div className="app">
      <AppHeader email={session.user.email ?? null} onSignOut={signOut} />
      <main className="page">
        <Routes>
          <Route path="/diary" element={<Diary />} />
          <Route path="/incidents/:incidentId" element={<IncidentView />} />
          <Route path="/devices" element={<Devices />} />
          <Route path="/devices/:deviceId/:section?" element={<DeviceSettings />} />
          <Route path="/claim" element={<Claim />} />
          {/* Placeholders for features not built yet. */}
          <Route path="/guide" element={<ComingSoon title="Device guide" blurb="Step-by-step help for placing, powering and training your BotherLog." />} />
          <Route path="/help" element={<ComingSoon title="Help & support" blurb="Troubleshooting, FAQs and device information will live here." />} />
          <Route path="/shop" element={<ComingSoon title="Get another BotherLog" blurb="Cover more of your home with an additional device — available soon." />} />
          <Route path="*" element={<Navigate to="/diary" replace />} />
        </Routes>
      </main>
    </div>
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Gate />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
